var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-h-10 tw-min-h-full"},[_c('div',{staticClass:"tw-flex tw-items-center tw-space-x-1"},[_c('SvgIcon',{staticClass:"tw-w-5 tw-h-5 tw-text-purple-500",attrs:{"name":"info-circle"}}),_c('span',{staticClass:"tw-font-medium tw-text-purple-700"},[_vm._v(" Non working day ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }